import { toast } from "react-toastify";
import ToastMessage from "../components/Toast/ToastMessage";
import { announce } from "./a11y/announcer";

export const PERMISSION_DENIED_MESSAGE =
  "Você não tem permissão para realizar essa ação";

// Central place that owns how toasts are rendered across the app. Call sites
// should use these helpers instead of importing `toast` from react-toastify
// directly, so the toast's look/behavior only needs to change here.
// `description` is optional complementary info shown below the main message.
const notify = (type, message, description) => {
  const isError = type === "error";

  // MUI dialogs aria-hide the toast container; this reaches the open dialog's live region instead
  announce(
    [message, description].filter(Boolean).join(". "),
    isError ? "assertive" : "polite"
  );

  return toast(ToastMessage, {
    type,
    role: isError ? "alert" : "status",
    data: { message, description },
  });
};

export const toastSuccess = (message, description) =>
  notify("success", message, description);

export const toastError = (message, description) =>
  notify("error", message, description);

export const toastWarning = (message, description) =>
  notify("warning", message, description);

export const toastDismiss = (...args) => toast.dismiss(...args);
